export const buttonTexts = {
    filterOpen: "Filtreler",
    filterClear: "Filtreyi Temizle",
    filterSubmit: "Hazırla",
    add: "Ekle",
    addWithErp: "Erp'den Aktar",
    addWithExcel: "Excel'den Aktar",
    exportToExcel: "Excel'e Aktar",
    save: "Kaydet",
    update: "Güncelle",
    goToBack: "Geri Dön",
    moreFilter: "Daha Fazla Filtre",
    lessFilter: "Daha Az Filtre"
}